'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

require('./ui-bkg-video.less');

var _helperEvents = require('@rnb/helper-events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BkgVideo = function (_Component) {
    _inherits(BkgVideo, _Component);

    function BkgVideo(props) {
        _classCallCheck(this, BkgVideo);

        var _this = _possibleConstructorReturn(this, (BkgVideo.__proto__ || Object.getPrototypeOf(BkgVideo)).call(this, props));

        _this.autoplay = (0, _get2.default)(props, 'autoplay');
        _this.isPlaying = true;
        _this.loop = (0, _get2.default)(props, 'loop');
        _this.preload = (0, _get2.default)(props, 'preload', 'auto');
        _this.wrapperExtraClasses = (0, _get2.default)(props, 'wrapperExtraClasses', '');
        _this.videoExtraClasses = (0, _get2.default)(props, 'videoExtraClasses', '');
        _this.videoPosterExtraClass = (0, _get2.default)(props, 'videoPosterExtraClass');
        _this.videoPosterHiddenClass = (0, _get2.default)(props, 'videoPosterHiddenClass');
        _this.playsinline = (0, _get2.default)(props, 'playsinline', '');
        _this.srcDesktop = (0, _get2.default)(props, 'srcDesktop');
        _this.srcMobile = (0, _get2.default)(props, 'srcMobile');
        _this.posterSmallDevice = (0, _get2.default)(props, 'posterSmallDevice');
        _this.posterLargeDevice = (0, _get2.default)(props, 'posterLargeDevice');
        _this.posterAlt = (0, _get2.default)(props, 'posterAlt');
        _this.ref_ui_bkg_video = _react2.default.createRef();
        _this.videoElement = null;
        _this.poster = _this.getPosterImage();
        _this.checkPlayInterval = null;

        _this.state = {
            posterHidden: false
        };
        return _this;
    }

    _createClass(BkgVideo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.videoElement = this.ref_ui_bkg_video.current;

            setTimeout(function () {
                if (_this2.checkPlayInterval) {
                    clearInterval(_this2.checkPlayInterval);
                    _this2.checkPlayInterval = null;
                }
            }, 20000);

            this.checkPlayInterval = setInterval(function () {
                if (!_this2.videoElement.paused) {
                    _this2.setState({ posterHidden: true });
                    if (_this2.checkPlayInterval) {
                        clearInterval(_this2.checkPlayInterval);
                        _this2.checkPlayInterval = null;
                    }
                }
            }, 200);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.isUnmounting = true;

            if (this.onScrollSubscription) {
                this.onScrollSubscription.remove();
            }
        }
    }, {
        key: 'isRefUiBkgVideoReady',
        value: function isRefUiBkgVideoReady() {
            if (this.videoElement && this.videoElement.play) {
                this.initListeners();
            }
        }
    }, {
        key: 'initListeners',
        value: function initListeners() {
            var _this3 = this;

            _helperEvents.EventAggregator.initListeners();
            this.onScrollSubscription = _helperEvents.EventAggregator.subscribe("onScroll", function () {
                return _this3.onScroll();
            });
            this.onScroll();
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            if (this.videoElement && this.videoElement.play) {
                if (this.isEnoughVideoAreaInViewPort() && !this.isPlaying) {
                    this.videoElement.play();
                    this.isPlaying = true;
                } else if (!this.isEnoughVideoAreaInViewPort() && this.isPlaying) {
                    this.videoElement.pause();
                    this.isPlaying = false;
                }
            }
        }
    }, {
        key: 'isEnoughVideoAreaInViewPort',
        value: function isEnoughVideoAreaInViewPort() {
            var rect = this.videoElement.getBoundingClientRect();

            return rect.bottom > 0 ? true : false;
        }
    }, {
        key: 'getPosterImage',
        value: function getPosterImage() {
            if (_helperEvents.EventAttributeStore.getCurrentWindowWidth() < this.props.breakPointSmallDevice) {
                return typeof this.posterSmallDevice !== 'undefined' ? this.posterSmallDevice : this.posterLargeDevice;
            } else {
                return this.posterLargeDevice;
            }
        }
    }, {
        key: 'getVideoSource',
        value: function getVideoSource() {
            if (_helperEvents.EventAttributeStore.getCurrentWindowWidth() < this.props.breakPointSmallDevice) {
                return typeof this.srcMobile !== 'undefined' ? this.srcMobile : this.srcDesktop;
            } else {
                return this.srcDesktop;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                { className: ['ui-bkg-video-wrapper', this.wrapperExtraClasses].join(" ") },
                this.poster && _react2.default.createElement('img', { alt: this.posterAlt ? this.posterAlt : "", src: this.poster, fetchpriority: 'high',
                    className: ['ui-bkg-video-poster', this.videoPosterExtraClass ? this.videoPosterExtraClass : "", this.state.posterHidden ? this.videoPosterHiddenClass ? this.videoPosterHiddenClass : 'ui-bkg-video-poster-hidden' : ""].join(' ') }),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'video',
                        {
                            ref: this.ref_ui_bkg_video,
                            onPlay: function onPlay() {
                                _this4.setState({ posterHidden: true });
                                _this4.isRefUiBkgVideoReady();
                            },
                            onError: function onError(e) {
                                console.log(e);
                            },
                            className: 'ui-bkg-video ' + this.videoExtraClasses,
                            muted: true,
                            loop: this.loop,
                            poster: this.poster,
                            preload: this.preload,
                            playsInline: this.playsinline ? 1 : 0,
                            autoPlay: this.autoplay ? 'yes' : undefined
                        },
                        _react2.default.createElement('source', { src: this.getVideoSource(), type: 'video/mp4' })
                    )
                ),
                this.props.children
            );
        }
    }]);

    return BkgVideo;
}(_react.Component);

exports.default = BkgVideo;
;